import mvtNearbyAfford from '@/common/components/mvtnearbyafford/mvt-nearbyafford.vue';
import { mapGetters } from 'vuex';

export default {
    name: 'dppNearbyAfford',
    inject: ['$eventBus'],
    computed:{
        ...mapGetters('glb', ['glb']),
        ...mapGetters('dpp', ['dpp']),
    },
    components: {
        mvtNearbyAfford
    },
    methods:{
        updateAffordInfo(e){
            this.dpp.affordMonthPay = e.monthPay;
            this.dpp.affordTotal = e.total;
        },
        load(){
            this.$refs.nearbyafford.refresh(this.dpp.price, this.dpp.geo.state, this.dpp.geo.cityCode, this.dpp.bed, this.dpp.bath);
        }
    }
};